import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function BrandAcif({ idVariant = '', className }: Props) {
  return (
    <IconBase name="brand-acif" w={96} h={12} className={className}>
      <path
        d="M50.0543 11.1339H62.7445V9.60711H50.0543C49.6346 9.60711 49.2774 9.45532 48.9916 9.14282C48.6969 8.83032 48.554 8.45532 48.554 7.99997V3.27675C48.554 2.83032 48.6969 2.44639 48.9916 2.13389C49.2863 1.82139 49.6346 1.66961 50.0543 1.66961H62.7445V0.142822H50.0543C49.2506 0.142822 48.5629 0.446394 47.9825 1.06247C47.4109 1.66961 47.1162 2.40175 47.1162 3.26782V7.99104C47.1162 8.84818 47.402 9.58925 47.9825 10.2053C48.554 10.8214 49.2417 11.125 50.0543 11.125"
        fill="currentColor"
      />
      <path d="M72.0412 0.142822H70.6123V11.125H72.0412V0.142822Z" fill="currentColor" />
      <path
        d="M82.8198 0.142822C82.0071 0.142822 81.3106 0.446394 80.739 1.06247C80.1764 1.66961 79.8906 2.40175 79.8906 3.27675V11.1339H81.3195V6.39282H95.5189V4.88389H81.3195V3.27675C81.3195 2.83032 81.4624 2.44639 81.7571 2.13389C82.0518 1.82139 82.409 1.66961 82.8287 1.66961H95.5189V0.142822H82.8287H82.8198Z"
        fill="currentColor"
      />
      <path
        d="M35.0419 1.66961H26.7008C26.2811 1.66961 25.9239 1.82139 25.6292 2.13389C25.3345 2.44639 25.1916 2.82139 25.1916 3.27675V4.88389H37.9532V3.27675C37.9532 2.83032 37.8103 2.44639 37.5156 2.13389C37.2209 1.82139 36.8726 1.66961 36.4529 1.66961H35.0419ZM26.7008 0.142822H36.4529C37.2655 0.142822 37.9621 0.446394 38.5337 1.06247C39.0963 1.66961 39.382 2.40175 39.382 3.27675V6.39282V11.1339H37.9532V6.39282H25.1916V11.1339H23.7627V3.27675C23.7627 2.41068 24.0485 1.66961 24.6111 1.06247C25.1826 0.446394 25.8792 0.142822 26.6919 0.142822"
        fill="currentColor"
      />
      <path
        d="M7.16095 0H15.6806V8.70536C14.725 4.42857 11.4029 1.04464 7.16095 0ZM4.61577 0H4.82117C5.90175 0.223214 8.62554 1.35714 8.62554 7.02679C14.6089 7.02679 15.5377 10.0536 15.6806 11.0089V11.2679H0.0791016V0H4.61577Z"
        fill="currentColor"
      />
    </IconBase>
  )
}

export default BrandAcif
